module.exports = __webpack_public_path__ + "static/media/application_process.99867162.png";